import {
  JWT_ACCESS_TOKEN,
  USER_INFO,
  MEMBERSHIPS,
} from '~/src/constants/common'
import useAuthStore from '~/stores/auth'
import { useMembershipsStore } from '~/stores/memberships'

export default defineNuxtRouteMiddleware(async () => {
  const { $cookies, $membershipApi } = useNuxtApp()
  const jwtToken = $cookies.get(JWT_ACCESS_TOKEN)
  const user = $cookies.get(USER_INFO)
  const memberships = $cookies.get(MEMBERSHIPS)
  const authStore = useAuthStore()
  const membershipsStore = useMembershipsStore()

  if (jwtToken && user) {
    authStore.setJwtToken(jwtToken)
    authStore.setUser(user)

    if (memberships) {
      membershipsStore.setActiveMembershipStatuses(memberships)
    } else {
      // If we don't have memberships in cookies but the user is authenticated,
      // fetch them from the server
      await $membershipApi.getActiveMemberships()
    }
  } else {
    // Clear memberships if the user is not authenticated
    membershipsStore.clearKeys()
  }
})
